export function profileInitials(givenName: string | null | undefined, surname: string | null | undefined) {
  return ((givenName?.trim()[0] ?? '') + (surname?.trim()[0] ?? '')).toUpperCase();
}

export function profileUserName(
  givenName: string | null | undefined,
  surname: string | null | undefined,
  displayName?: string | null
) {
  return [givenName?.trim(), surname?.trim()].filter(Boolean).join(' ') || displayName?.trim() || '';
}
